import { buildWeekRow, toDateKey, isPastDate, isFutureLockedDate, weekdayKeyOf, weekdayShort } from './dateUtils';
import { computeEffectiveSlots, statusColors, bookingCountsForDate, withRemainingCapacity } from './useEffectiveSlots';
import { formatTime12h } from '../../utils/helpers';

export default function WeekView({ currentDate, weeklySlots, slotOverrides, bookings = [], onSelectDate }) {
  const days = buildWeekRow(currentDate);
  const today = new Date();
  const todayKey = toDateKey(today);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-7 gap-2">
      {days.map(date => {
        const dateKey = toDateKey(date);
        const rawEffective = computeEffectiveSlots(weeklySlots, slotOverrides, dateKey, weekdayKeyOf(date));
        const counts = bookingCountsForDate(bookings, dateKey);
        const effective = { ...rawEffective, slots: withRemainingCapacity(rawEffective.slots, counts) };
        const isToday = dateKey === todayKey;
        const isPast = isPastDate(date, today);
        const isFutureLocked = isFutureLockedDate(date, today);
        const isLocked = isPast || isFutureLocked;
        const colors = statusColors(effective, isLocked);
        return (
          <div key={dateKey} className="rounded-2xl border p-3 flex flex-col bg-white dark:bg-[#303134]"
            style={{
              backgroundColor: colors ? colors.bg : undefined,
              opacity: isLocked ? 0.6 : undefined,
              borderColor: isToday ? '#1a73e8' : undefined,
              borderWidth: isToday ? 2 : 1,
            }}>
            <button type="button" onClick={() => onSelectDate(date)} disabled={isLocked}
              className={'text-left mb-2' + (isLocked ? ' cursor-not-allowed' : ' cursor-pointer')}>
              <p className="text-[11px] font-semibold uppercase tracking-widest text-[#9aa0a6]">{weekdayShort(date)}</p>
              <p className={'text-sm font-bold' + (isToday ? ' text-[#1a73e8]' : isLocked ? ' text-[#9aa0a6]' : ' text-[#202124] dark:text-[#e8eaed]')}>{date.getDate()}</p>
            </button>
            <div className="flex-1 space-y-1">
              {effective.slots.length === 0 && <p className="text-xs text-[#dadce0] dark:text-[#3c4043]">—</p>}
              {effective.slots.map((slot, i) => (
                <div key={slot._id || i} className="text-[11px] px-2 py-1 rounded-lg bg-[#f8fafd] dark:bg-[#202124]/50 text-[#5f6368] dark:text-[#9aa0a6]">
                  {formatTime12h(slot.startTime)}–{formatTime12h(slot.endTime)} · {slot.remainingCapacity}/{slot.capacity} open
                </div>
              ))}
            </div>
            {!isLocked && (
              <button type="button" onClick={() => onSelectDate(date)}
                className="mt-2 text-[11px] font-semibold text-[#1a73e8] dark:text-[#8ab4f8] hover:underline cursor-pointer">
                + Manage
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
